"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ListItem = /*#__PURE__*/(0, _base.default)("li", process.env.NODE_ENV === "production" ? {
  target: "e8hjcxt0"
} : {
  target: "e8hjcxt0",
  label: "ListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "n1lsvi",
  styles: "padding:0;list-style:none"
} : {
  name: "n1lsvi",
  styles: "padding:0;list-style:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _default = exports.default = ListItem;